import Component from '@glimmer/component';
import { service } from '@ember/service';
import { array } from '@ember/helper';
import { t } from 'ember-intl';
import pageTitle from 'ember-page-title/helpers/page-title';
import ReportViewPage from 'tio-reporting/components/report-view/page';
import { VStack } from 'tio-ui/components/layout';
import type ReportViewerController from 'tio-employee/controllers/authenticated/admin/reporting/report-viewer';
import type RouterService from '@ember/routing/router-service';

interface ReportViewerRouteSignature {
  Args: {
    controller: ReportViewerController;
  };
}

class ReportViewerRouteComponent extends Component<ReportViewerRouteSignature> {
  @service declare router: RouterService;

  handleBack = () => {
    this.router.transitionTo('authenticated.admin.reporting');
  };

  <template>
    {{pageTitle (t "reporting.reports")}}
    {{! Wrap in the standard page container (like every sibling page) — the
        viewer brings its own header bar and would otherwise render full-bleed,
        butted against the app chrome. }}
    <VStack>
      <ReportViewPage
        @controller={{@controller}}
        @viewedFrom="partner"
        @allowedReportTypes={{array "tas"}}
        @onBack={{this.handleBack}}
      />
    </VStack>
  </template>
}

export default ReportViewerRouteComponent;
